import React from "react";
import ReactDOM from "react-dom";
import Routes from "./config/routes";
import { AuthProvider } from "./authContext";

import { QueryClient, QueryClientProvider } from 'react-query';

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline } from "@material-ui/core";

const queryClient = new QueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <React.Fragment>
      <AuthProvider>
        <ToastContainer
          autoClose={2000}
          position="top-center"
          className="toast-container"
          toastClassName="dark-toast"
        />
        <CssBaseline />
        <Routes />
      </AuthProvider>
    </React.Fragment>
  </QueryClientProvider>,
  document.getElementById("root")
);
